import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useU2000LocalStorage from "../../hooks/U2000UseLocalStorage";
import useU2000RefreshToken from "../../hooks/authentification/U2000UseRefrehToken";
import { u2000Menu } from "../../menu/U2000Menu";
import { U2000MenuFindMenuItemFromPath, U2000MenuFindModuleFromPath } from "../../menu/U2000MenuUtils";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

// Types for auth context (adjust as needed)
interface Auth {
  isAuthenticated: boolean;
  menu: any; // Replace 'any' with your menu type if available
}

type MenuItem = {
  id?: string | number;
};

// Type for useU2000AuthContext return (adjust as needed)
interface U2000AuthContextType {
  auth: Auth;
  setCurrentModule: (module: any) => void;
  setCurrentMenuItem: (id: string) => void;
}

const U2000PersistLogin: React.FC = () => {
  const { auth, setCurrentModule, setCurrentMenuItem } = useU2000AuthContext() as U2000AuthContextType;
  const doRrefreshToken: (menu: any) => Promise<void> = useU2000RefreshToken();
  const [persist] = useU2000LocalStorage("persist", false) as [boolean, (newValue: boolean | ((prev: boolean) => boolean)) => void];
  const [isLock, setLock] = useState<boolean>(true);
  const [initPersist, setIinitPersist] = useState<boolean>(false);
  // const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    console.log("🔄 [U2000PersistLogin] useEffect:", {
      isAuthenticated: auth?.isAuthenticated,
      persist,
      userName: (auth as any)?.user?.userName,
    });

    const refreshToken = async () => {
      console.log("🔄 [U2000PersistLogin] refreshToken appelé");
      try {
        await doRrefreshToken(u2000Menu);
        setIinitPersist(true);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        if (isMounted) {
          setLock(false);
        }
      }
    };

    if (!auth?.isAuthenticated && persist) {
      console.log("🚨 [U2000PersistLogin] Non authentifié avec persist=true, lancement refreshToken");
      refreshToken();
    } else {
      console.log("✅ [U2000PersistLogin] Pas de refresh nécessaire");
      setLock(false);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (initPersist) {
      const menuItem: MenuItem | null = U2000MenuFindMenuItemFromPath(auth.menu, window.location.pathname);
      if (menuItem && menuItem.id !== undefined) {
        setCurrentMenuItem(menuItem.id.toString());
        const currentModule = U2000MenuFindModuleFromPath(auth.menu, window.location.pathname);
        setCurrentModule(currentModule);
      }
      setIinitPersist(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return <>{!persist ? <Outlet /> : isLock ? <p>lock...!</p> : <Outlet />}</>;
};

export default U2000PersistLogin;
